const HandleUpload = {
  methods: {
    chooseFiles(elementId) {
      document.getElementById(elementId).click();
    },
    handleFileChange(e) {
      if (!e.target.files) return;
      this.$store
        .dispatch("upload/uploadFileAsync", e.target.files)
        .then((file) => {
          this.$emit("uploadSuccess", file);
        });
    },
  },
};
export default HandleUpload;
